import { IAccessory, IConfiguration, ITireSet, OrderSource, isStockSaleOrderToBeProcessed } from 'next-common';
import { useEffect } from 'react';
import { useClientLazyQuery } from './useClientLazyQuery';
import { NEXT_ENTITY } from '@common/interfaces';

export interface IUseVehicleTyreAccResponse {
  tires: ITireSet[];
  accessories: IAccessory[];
  isTyreAccLoading: boolean;
}

export interface IVehicleTyreAccProps {
  orderId: string;
  source?: OrderSource;
  serialNo?: string;
  make?: string;
  configuration?: IConfiguration;
  isUsedCar?: boolean;
}

export const useVehicleTyreAccessories = (props: IVehicleTyreAccProps): IUseVehicleTyreAccResponse => {
  const { data, loading } = useVehicleTyreAccessoriesQuery(props);
  return { tires: data?.tires, accessories: data?.accessories, isTyreAccLoading: loading };
};

const useVehicleTyreAccessoriesQuery = (props: IVehicleTyreAccProps) => {
  useEffect(() => {
    const isStockSaleOrder = isStockSaleOrderToBeProcessed(
      props?.configuration,
      props?.source,
      props?.serialNo,
      props?.make
    );

    if (!props?.isUsedCar && isStockSaleOrder) {
      vehicleAccessories();
    }
  }, [props?.orderId, props?.source, props?.configuration, props?.serialNo]);

  const [vehicleAccessories, { loading, data }] = useClientLazyQuery(
    NEXT_ENTITY.VEHICLE_ACCESSORIES_WITH_SERIAL_NUMBER,
    {
      variables: {
        serialNo: props?.serialNo || '',
      },
    }
  );

  return { data: data, loading };
};
